// Components/About/WhoWeAre.jsx
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const fadeRight = {
  hidden: { opacity: 0, x: 60 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

const WhoWeAre = () => {
  return (
    <section className="pt-8 pb-12 md:pb-16 px-6">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 items-center lg:pr-20">

        {/* LEFT: Images */}
        <motion.div
          className="relative max-w-sm mx-auto lg:mx-0 lg:ml-auto grid grid-cols-2 gap-3"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="flex flex-col gap-3">
            <motion.div variants={fadeLeft} className="h-[140px] rounded-lg overflow-hidden shadow-md">
              <img src="/Images/about3.png" alt="Construction" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div variants={fadeLeft} className="h-[140px] rounded-lg overflow-hidden shadow-md">
              <img src="/Images/about1.png" alt="Construction" className="w-full h-full object-cover" />
            </motion.div>
          </div>

          <div className="flex flex-col gap-3 mt-6">
            <motion.div variants={fadeLeft} className="h-[140px] rounded-lg overflow-hidden shadow-md">
              <img src="/Images/about2.png" alt="Construction" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div variants={fadeLeft} className="h-[140px] rounded-lg overflow-hidden shadow-md">
              <img src="/Images/about4.png" alt="Construction" className="w-full h-full object-cover" />
            </motion.div>
          </div>

          {/* Glow */}
          <div className="absolute -top-4 -left-4 w-16 h-16 bg-[#343a40]/20 rounded-full blur-xl" />
          <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-[#343a40]/20 rounded-full blur-xl" />
        </motion.div>

        {/* RIGHT: Text */}
        <motion.div
          className="space-y-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.p
            variants={fadeRight}
            className="text-[#6c757d] uppercase tracking-wider text-xs md:text-sm font-semibold"
          >
            Who We Are
          </motion.p>

          <motion.h2
            variants={fadeRight}
            className="text-2xl md:text-3xl font-bold text-[#212529]"
          >
            Building Excellence for Generations
          </motion.h2>

          <motion.p variants={fadeRight} className="text-[#495057] text-sm leading-relaxed">
            <span className="font-semibold text-[#212529]">
              Ashlar is a third-generation general contracting firm
            </span>{" "}
            with over 45 years of hands-on experience.
          </motion.p>

          <motion.p variants={fadeRight} className="text-[#495057] text-sm leading-relaxed">
            We combine craftsmanship, integrity, and modern construction
            practices to deliver projects built to last.
          </motion.p>

          {/* Key Points */}
          <motion.div className="flex flex-col gap-3 pt-2" variants={staggerContainer}>
            {[
              "Third-generation expertise with 45+ years experience",
              "Deeply rooted in hands-on construction trades",
              "Fully licensed and insured professionals",
              "Quality-first approach with no shortcuts",
            ].map((text, i) => (
              <motion.div key={i} variants={fadeRight} className="flex items-start gap-2">
                <div className="w-4 h-4 bg-[#212529] rounded-full flex items-center justify-center mt-1 flex-shrink-0">
                  <svg className="w-2.5 h-2.5 text-[#f8f9fa]" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l6.879-6.879a1 1 0 011.414 0z" />
                  </svg>
                </div>
                <p className="text-xs md:text-sm text-[#495057]">{text}</p>
              </motion.div>
            ))}
          </motion.div>

          <motion.div variants={fadeRight}>
            <Link to="/process">
              <button className="mt-4 bg-[#343a40] hover:bg-[#495057] text-[#f8f9fa] px-6 py-2.5 rounded-full text-sm font-semibold transition">
                Learn About Our Process →
              </button>
            </Link>
          </motion.div>
        </motion.div>

      </div>
    </section>
  );
};

export default WhoWeAre;